import customEventBus from '@common/scripts/libs/eventBus';
import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
const RegistrationSuccessful = (props) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: classNames('login-registration__registration-successful', props.classNames) },
        React.createElement("h2", { className: "mt-64 mb-8 primary-m" }, t('modal.loginregister.successfull')),
        React.createElement("p", { className: "primary-xs" }, t('modal.loginregister.thankyou1')),
        React.createElement("p", { className: "mb-24 primary-xs" }, t('modal.loginregister.thankyou2')),
        React.createElement("button", { type: "button", "aria-label": t('button.close'), className: "button button--primary primary-xs", onClick: () => {
                if (props.reloadComponent && props.updateLoggedStatus) {
                    props.updateLoggedStatus(true);
                    window.loggedin = true;
                    customEventBus.emit('account:update', {});
                }
                else if (props.reloadPage) {
                    window.location.reload();
                }
                else {
                    props.closeModal();
                }
            } }, t('modal.loginregister.keepbrowsing'))));
};
export default RegistrationSuccessful;
